import { render, staticRenderFns } from "./ImageForm.vue?vue&type=template&id=c54b0ee2&scoped=true&"
import script from "./ImageForm.vue?vue&type=script&lang=js&"
export * from "./ImageForm.vue?vue&type=script&lang=js&"
import style0 from "./ImageForm.vue?vue&type=style&index=0&id=c54b0ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54b0ee2",
  null
  
)

export default component.exports